export default "__VITE_ASSET__DbhBEMEM__"